export default __webpack_public_path__ + "f81f461008851bfa885a3a7619956ac3.pdf";